import { Boundaries } from "@planzone/core";
import { Identifiable, List } from "@planzone/dto";
import { events } from "@planzone/events";
import { reduceTask } from "../task";
import { reduceMilestone } from "../milestone";
import { reduceEvent } from "../event";

function handleRemoveTagRequest(
  list: Identifiable<List>,
  data: Boundaries["removeTag"]["request"],
): Identifiable<List> {
  return list.uuid === data.removableId
    ? {
        ...list,
        tags: list.tags.filter(({ name }) => name !== data.tag.name),
      }
    : {
        ...list,
        tasks: list.tasks.map((task) =>
          reduceTask(task, { type: events.removeTagRequested, data }),
        ),
        milestones: list.milestones.map((milestone) =>
          reduceMilestone(milestone, { type: events.removeTagRequested, data }),
        ),
        events: list.events.map((event) =>
          reduceEvent(event, { type: events.removeTagRequested, data }),
        ),
        subLists: list.subLists.map((subList) =>
          handleRemoveTagRequest(subList, data),
        ),
      };
}

function handleRemoveTagSuccess(
  list: Identifiable<List>,
  data: Boundaries["removeTag"]["success"],
): Identifiable<List> {
  return list.uuid === data.removableId
    ? {
        ...list,
        tags: list.tags.filter(({ name }) => name !== data.tag.name),
      }
    : {
        ...list,
        tasks: list.tasks.map((task) =>
          reduceTask(task, { type: events.removeTagRequested, data }),
        ),
        milestones: list.milestones.map((milestone) =>
          reduceMilestone(milestone, { type: events.removeTagRequested, data }),
        ),
        events: list.events.map((event) =>
          reduceEvent(event, { type: events.removeTagRequested, data }),
        ),
        subLists: list.subLists.map((subList) =>
          handleRemoveTagRequest(subList, data),
        ),
      };
}

function handleRemoveTagFailure(
  list: Identifiable<List>,
  data: Boundaries["removeTag"]["failure"],
): Identifiable<List> {
  return list.uuid === data.removableId
    ? {
        ...list,
        tags: list.tags ? [...list.tags, data.tag] : [data.tag],
      }
    : {
        ...list,
        tasks: list.tasks.map((task) =>
          reduceTask(task, { type: events.removeTagFailed, data }),
        ),
        milestones: list.milestones.map((milestone) =>
          reduceMilestone(milestone, { type: events.removeTagFailed, data }),
        ),
        events: list.events.map((event) =>
          reduceEvent(event, { type: events.removeTagFailed, data }),
        ),
        subLists: list.subLists.map((subList) =>
          handleRemoveTagFailure(subList, data),
        ),
      };
}

export {
  handleRemoveTagRequest,
  handleRemoveTagSuccess,
  handleRemoveTagFailure,
};
